<template>
  <UiBaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    class="icon"
  >
    <path
      d="M10.0003 1.66675C5.39199 1.66675 1.66699 5.39175 1.66699 10.0001C1.66699 14.6084 5.39199 18.3334 10.0003 18.3334C14.6087 18.3334 18.3337 14.6084 18.3337 10.0001C18.3337 5.39175 14.6087 1.66675 10.0003 1.66675ZM13.5837 13.5834C13.2587 13.9084 12.7337 13.9084 12.4087 13.5834L10.0003 11.1751L7.59199 13.5834C7.26699 13.9084 6.74199 13.9084 6.41699 13.5834C6.09199 13.2584 6.09199 12.7334 6.41699 12.4084L8.82533 10.0001L6.41699 7.59175C6.09199 7.26675 6.09199 6.74175 6.41699 6.41675C6.74199 6.09175 7.26699 6.09175 7.59199 6.41675L10.0003 8.82508L12.4087 6.41675C12.7337 6.09175 13.2587 6.09175 13.5837 6.41675C13.9087 6.74175 13.9087 7.26675 13.5837 7.59175L11.1753 10.0001L13.5837 12.4084C13.9003 12.7251 13.9003 13.2584 13.5837 13.5834Z"
      fill="#BBBCBF"
    />
  </UiBaseIcon>
</template>

<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';
</script>
